import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  handlePageSettings,
  handleSearchSettings,
} from "../redux/counterSlice";
// import debounce from "lodash.debounce";
// import { useCallback } from "react";
// import { useRef } from "react";

export const useTablePagination = (screen, defaultRowsPerPage = 10) => {
  const dispatch = useDispatch();

  // Read current page, rowsPerPage, and search text from Redux
  const pageSettings = useSelector(
    (state) => state.counter.pageSettings?.[screen]
  );
  const searchText = useSelector(
    (state) => state.counter.searchSettings?.[screen] || ""
  );

  const page = pageSettings?.pageNo || 0;
  const rowsPerPage = pageSettings?.pageSize || defaultRowsPerPage;

  // Handler for page change
  const onChangePage = (newPage) => {
    dispatch(
      handlePageSettings({
        screen,
        pageNo: newPage,
        pageSize: rowsPerPage,
      })
    );
  };

  // Handler for rows per page change
  const onChangeRowsPerPage = (newRowsPerPage) => {
    dispatch(
      handlePageSettings({
        screen,
        pageNo: 0, // reset to first page
        pageSize: newRowsPerPage,
      })
    );
  };

  // Handler for search text change
  const onSearchChange = (newSearchText) => {
    dispatch(
      handleSearchSettings({
        screen,
        value: newSearchText,
      })
    );
  };

  // const lastSearch = useRef("");
  // // Debounced search function
  // const debouncedSearchChange = useCallback(
  // debounce((value) => {
  //     if (value === lastSearch.current) return; // skip same value
  //     lastSearch.current = value;
  //     onSearchChange(value);
  // }, 300),
  // []
  // );

  return {
    page,
    rowsPerPage,
    searchText,
    // debouncedSearchChange, // return this for use in components
    onChangePage,
    onChangeRowsPerPage,
    onSearchChange,
  };
}

// Separate hook for table height for fixed header muidatatables
export function useTableHeight() {
  const calcTableHeight = () => window.innerHeight - 160 + "px";

  const [tableHeight, setTableHeight] = useState(calcTableHeight);

  useEffect(() => {
    const handleResize = () => setTableHeight(calcTableHeight());

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return tableHeight;
}
